import { render, staticRenderFns } from "./ServiceAppointingRider.vue?vue&type=template&id=af80bf02&scoped=true&"
import script from "./ServiceAppointingRider.vue?vue&type=script&lang=js&"
export * from "./ServiceAppointingRider.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAppointingRider.vue?vue&type=style&index=0&id=af80bf02&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af80bf02",
  null
  
)

export default component.exports